import {
  postData,
  getData,
  deleteData,
  putData
} from './request'

// 获取文件列表
export function getFiles({group,offset,filter,orderby,order,parentid,count,search,trash,fid,tid}, cb) {
    let url = search ? 
        `/api/v3/search/files?count=${count}&offset=${offset}&searchname=${encodeURIComponent(search)}` :
        trash ?
        `/api/v3/recycles/subfiles?count=${count}&offset=${offset}&parent=${fid ? fid : -1}` :
        `/api/v3/groups/${tid || group}/files?offset=${offset}&count=${count}&filter=${filter}&orderby=${orderby}&order=${order}&parentid=${parentid}`
  return getData(url, {}, cb)
}

// 获取路径
export function loadPath({pid,fid}, cb) {
  let url = fid ? `/api/v3/recycles/path?fileid=${fid}` : `/api/files/${pid}/path`
  return getData(url, {}, cb)
}

// 更新文件信息
export function saveFile(paload, cb) {
  return postData(`/api/v3/groups/${paload.groupid}/files`, paload, {}, cb)
}

// 批量删除文档
export function deleteFils(paload, cb) {
  return postData(`/api/v3/new/groups/${paload.groupid}/files/batch/delete`, paload, {}, cb)
}

// 移动文件
export function moveFiles(paload, cb) {
  return postData(`/api/v3/groups/${paload.groupid}/files/batch/move`, paload, {}, cb)
}

// 复制文件
export function copy(paload, cb) {
  return postData(`/api/v3/groups/${paload.groupid}/files/batch/copy`, paload, {}, cb)
}

// 下载文件
export function download({groupid,fileid,sid,historyid}, cb) {
  let url = sid ? sid.length > 10 ? `https://drive.wps.com/api/v3/sharedocs/${sid}/download` : `https://drive.wps.com/api/share/shareinfo?link_suffix=${sid}` : historyid ? `/api/v3/files/${fileid}/histories/${historyid}/download?groupid=${groupid}` : `/api/v3/groups/${groupid}/files/${fileid}/download`
  return getData(url, {}, cb)
}

// 获取上传地址
export function fetchUploadFileUrl(params, cb) {
  return getData(`/api/files/upload/request`, {
    params
  }, cb)
}

// 创建文件
export function createFile(paload, cb) {
  paload.store = 's3_obs_oss'
  return postData(`/api/v3/groups/${paload.groupid}/files/new_empty`, paload, {}, cb)
}

// 清空回收站
export function emptyTrash(paload, cb) {
  return deleteData(`/api/v3/recycles`, paload, {}, cb)
}

// 创建分享链接
export function share(paload, cb) {
  // return postData(`/api/sharelinks`, {
  //   doc_type: 'drive',
  //   doc_id: paload.fileid
  // }, {}, cb)
  return postData(`/api/v3/groups/${paload.groupid}/files/${paload.fileid}/actions/share`, paload, {}, cb)
}

// 重命名
export function rename(paload, cb) {
  return putData(`/api/v3/groups/${paload.groupid}/files/${paload.fileid}`, paload, {}, cb)
}

// 获取历史版本
export function getHistory({fileid,offset,groupid,count}, cb) {
  return getData(`/api/v3/files/${fileid}/histories?offset=${offset}&count=${count}&groupid=${groupid}`, {}, cb)
}
// 恢复历史版本
export function dorecover(paload, cb) {
  return postData(`/api/v3/files/${paload.fileid}/histories/${paload.historyid}/recover`, paload, {}, cb)
}

// 恢复文件
export function recover(paload, cb) {
  return postData(`/api/v3/new/recycles/batch/recover`, paload, {}, cb)
}

// 彻底删除
export function deleteP(paload, cb) {
  return postData(`/api/v3/new/recycles/batch/destory`, paload, {}, cb)
}

// 查询扫描状态
export function shareScan({key,origin,region},cb){
  return getData(`https://drive.wps.com/api/v3/share/qr?key=${key}&origin=${origin}`, {
    headers: {
      "x-wps-region": region
    }
  }, cb)
}

// 扫描
export function doscan(paload,cb){
  return postData(`https://drive.wps.com/api/v3/groups/${paload.groupid}/files/${paload.fileid}/qr/share`,paload, {}, cb)
}

// 获取region
export function getRegion(paload,cb){
  return getData(`https://drive.wps.com/api/v3/share/qr/region`, {}, cb)
}
// 查询是否提示绑定邮箱
export function checkEmail(cb) {
  return getData(`https://account.wps.com/api/bind/remind`, {}, cb)
}

export function closeEmailTip(cb){
  return postData(`https://account.wps.com/api/bind/remind`, {
    seconds: 604800
  }, {}, cb)
}

export function sendEmail(email,cb){
  return postData(`https://account.wps.com/api/v3/mine/email/send`, {
    email
  }, {}, cb)
}


// WEBPACK FOOTER //
// ./src/store/service/index.js